import fetch from '@/utils/fetch'

// 菜谱导出
export const punchCardVideo = (data: any) =>
  fetch({
    url: '/api-home/organize/web/punchCardVideo/list',
    method: 'post',
    data
  })